import * as React from "react";

const ArrowSVG = ({ width = 16, height = 16, color = "%23212529" , isActive = false, rotate = 0, ...props }) => {
  const arrowColor = isActive ? "blue" : "#212529" ; 
  return(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill={arrowColor}
    width={width}
    height={height}
    style={{
      transform: `rotate(${rotate}deg)`,
      transition: "transform 0.3s ease", // Optional smooth animation
    }}
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
    />
  </svg>
  )
};

export default ArrowSVG;


